module.exports = __webpack_public_path__ + "static/media/puzzle-7-bg.b0740d35.svg";